const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];
/**
 * Sanitizes a URL by validating its protocol against an allowlist.
 * Returns an empty string for URLs with disallowed protocols (e.g. javascript:).
 */
export function sanitizeUrl(url) {
    if (!url)
        return '';
    const trimmed = url.trim();
    if (!trimmed)
        return '';
    try {
        // Handle protocol-relative URLs
        const resolved = trimmed.startsWith('//') ? `https:${trimmed}` : trimmed;
        // `.invalid` is an RFC 6761 reserved TLD that will never resolve.
        const parsed = new URL(resolved, 'https://placeholder.invalid');
        if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
            return '';
        }
    }
    catch {
        // Relative URLs (e.g. "/path/to/page") are safe
        if (trimmed.startsWith('/') || trimmed.startsWith('.')) {
            return trimmed;
        }
        return '';
    }
    return trimmed;
}
